import axios from "axios";

export const PostRequestAPI = async (apiurl, access_token, contentType, responseType,from_date,to_date,search,userId,recipientId,machineId,status) => {
    const headers = {
      'Accept':"application/json",
    }
    if(access_token){
      headers.Authorization = `Bearer ${access_token}`
    }
    if(contentType){
      headers['Content-Type']='multipart/form-data'
    }

    const params = {
        "from_date":from_date, 
        "to_date":to_date,
        "search":search,
        "user_id":userId,
        "recipient_id":recipientId,
        "machine_id":machineId,
        "status": status
      };

    const contentMethod = {
      headers:headers,
      params
    }

    if(responseType){
      contentMethod.responseType = responseType
    }
    const getResponse = axios.get(apiurl, contentMethod).then(function (result) {
      return result;
    }).catch((e)=>e.response);
    return getResponse;
};